import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyAbUY9L0NUr6437cV4Ejl9EoCdwAPxw9vU",
  authDomain: "netflix-clone-9d4f3.firebaseapp.com",
  projectId: "netflix-clone-9d4f3",
  storageBucket: "netflix-clone-9d4f3.appspot.com",
  messagingSenderId: "330684435348",
  appId: "1:330684435348:web:cdacbd6f9dae5bd83e1d81"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export {auth};
export default db;